// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__new6V","question":"styles_question__3omkF","description":"styles_description__3-Ig7"};